import { Analysis } from 'common-spectrum';
import { dscParseCPS } from 'physical-chemistry-parser';

export function fromCPS(text) {
  let analysis = new Analysis();
  const parsed = dscParseCPS(text);

  let meta = parsed.meta;

  analysis.pushSpectrum(
    {
      x: {
        data: parsed.data.Diam.data,
        label: parsed.data.Diam.label,
        units: parsed.data.Diam.units === 'microns' ? 'µm' : '',
        type: 'DEPENDENT',
      },
      y: {
        data: parsed.data.Weight.Height.data,
        label: parsed.data.Weight.Height.label,
        units: parsed.data.Weight.Height.units,
        type: 'DEPENDENT',
      },
      t: {
        data: parsed.data.Time.data,
        label: parsed.data.Time.label,
        units: parsed.data.Time.units === 'seconds' ? 's' : '',
        type: 'INDEPENDENT',
      },
    },
    {
      dataType: 'Differential Centrifugal Sedimentation (DCS)',
      title: meta['Sample description'],
      meta: parsed.meta,
    },
  );

  return analysis;
}
